@if(!isMobile){
@if(!isFY){
<section class="content">
    <div class="searchSec">
        <form>
            <div class="searchBox">
                <div class="inpSec">
                    <label class="inpLabel" for="">Search by family code</label>
                    <input type="text" [formControl]="searchFc" class="search-input dp-input-control"
                        placeholder="Enter the family code" (keydown)="restrictFCInput($event)" maxlength="12" />
                    <!-- <div class="errorSec" *ngIf="searchFc.errors && searchFc.touched">
              <small class="error-message" *ngIf="searchFc.errors ">Search field cannot be
                empty</small> -->

                    <!-- <small class="error-message" *ngIf="searchFc.errors.['pattern'] && searchFc.touched ">Special
                charaters not allowed</small> -->
                    <!-- </div> -->
                    <!-- @if(!isFY && reportDetails.length == 0){
             <div (click)="getReportDetails(false)" class="searchIco"></div>
          } @else{
          <div (click)="clearInp()" class="crossIco"></div>
          } -->
                </div>

                <div class="submitSec">
                    <button type="reset" class="dp-secondary-btn" (click)="clearInp()">
                        Clear
                    </button>
                    <button type="button" class="dp-primary-btn" (click)="getReportDetails(false)">
                        Search
                    </button>
                </div>
            </div>
        </form>
    </div>
</section>
}
@if(isFY){
<div class="d-flex inpSec align-items-center justify-content-between">
    <div class="d-flex">
        <input type="text" class="dp-input-control searchInput" [formControl]="searchReq"
            placeholder="Search by anything" />
    </div>

    <div class="d-flex terms">
        <div class="each-term" [class.active-term]="terms === '1st'" (click)="getTerms('1st')">
            <!-- <span class="common-txt">1st Term</span> -->
            1st Term
        </div>
        <div class="each-term" [class.active-term]="terms === '2nd'" (click)="getTerms('2nd')">
            2nd Term
        </div>
        <div class="each-term" [class.active-term]="terms == '3rd'" (click)="getTerms('3rd')">
            3rd Term
        </div>
        <div class="each-term" [class.active-term]="terms == '4th'" (click)="getTerms('4th')">
            4th Term
        </div>
        <div class="each-term" [class.active-term]="terms == 'custom'" (click)="getTerms('custom')">
            Customize
        </div>
    </div>

</div>
}

<div class="table-container">
    <table class="table">
        <!-- @if(isprofile && !isVisit){ -->
        @if(!isFY){
        <thead class="table-head">
            <tr>

                <th>
                    <span>Financial year</span>
                </th>
                <th>
                    <span>DP Received Deoghar</span>
                </th>
                <th>
                    <span>SP Received Deoghar</span>
                </th>
                <th>
                    <span>Online Mode Submitted</span>
                </th>
                <th>
                    <span>Offline Mode Submitted</span>
                </th>
            </tr>
        </thead>
        }@else {
        <thead class="table-head">
            <tr>

                <th>
                    <span>Submitted Date</span>
                </th>
                <th>
                    <span>DP Received Deoghar</span>
                </th>
                <th>
                    <span>SP Received Deoghar</span>
                </th>
                <th>
                    <span>Online Mode Submitted</span>
                </th>
                <th>
                    <span>Offline Mode Submitted</span>
                </th>
            </tr>
        </thead>
        }
        @if(!isFY){
        <tbody class="table-body">
            @if(reportDetails.length > 0){
            @for(row of reportDetails; track row){
            <tr>
                <td (click)="getDateDetails(row.period)" class="hover-item">
                    {{row.period}}
                </td>
                <td>
                    {{row.dpTotal}}
                </td>
                <td>
                    {{row.spTotal}}
                </td>
                <td>
                    {{row.onlineTotal}}
                </td>
                <td>
                    {{row.offlineTotal}}
                </td>
            </tr>
            }
            }@else{
            <tr>
                <td colspan="5" style="text-align: center;">
                    No Records Found
                </td>
            </tr>
            }
            <!-- <tr>
                    <td>
                        No Records Found
                    </td>
                </tr> -->
        </tbody>
        }@else {
        <tbody class="table-body">
            @if(!isActive){
            @if(dateDetails.length > 0){
            @for(row of dateDetails; track row){
            <tr>
                <td>
                    {{row.submitDate}}
                </td>
                <td>
                    {{row.dpTotal}}
                </td>
                <td>
                    {{row.spTotal}}
                </td>
                <td>
                    {{row.onlineTotal}}
                </td>
                <td>
                    {{row.offlineTotal}}
                </td>
            </tr>
            }
            }@else{
            <tr>
                <td colspan="5" style="text-align: center;">
                    No Records Found
                </td>
            </tr>
            }
            <!-- <tr>
                    <td>
                        No Records Found
                    </td>
                </tr> -->
            }@else{
            @if(filterData.length > 0){
            @for(row of filterData; track row){
            <tr>
                <td>
                    {{row.submitDate}}
                </td>
                <td>
                    {{row.dpTotal}}
                </td>
                <td>
                    {{row.spTotal}}
                </td>
                <td>
                    {{row.onlineTotal}}
                </td>
                <td>
                    {{row.offlineTotal}}
                </td>
            </tr>
            }
            }@else{
            <tr>
                <td colspan="5" style="text-align: center;">
                    No Records Found
                </td>
            </tr>
            }
            }
        </tbody>
        }
    </table>

</div>
}

@if(isMobile){
@if(!isFY){
<section class="content">
    <div class="searchSec">
        <form>
            <div class="searchBox">
                <div class="inpSec">
                    <label class="inpLabel" for="">Search by family code</label>
                    <input type="text" [formControl]="searchFc" class="search-input dp-input-control"
                        placeholder="Enter the family code" (keydown)="restrictFCInput($event)" maxlength="12" />
                    <!-- <div class="errorSec" *ngIf="searchFc.errors && searchFc.touched">
              <small class="error-message" *ngIf="searchFc.errors ">Search field cannot be
                empty</small> -->

                    <!-- <small class="error-message" *ngIf="searchFc.errors.['pattern'] && searchFc.touched ">Special
                charaters not allowed</small> -->
                    <!-- </div> -->
                    @if(!isFY && reportDetails.length == 0){
                    <div (click)="getReportDetails(false)" class="searchIco"></div>
                    } @else{
                    <div (click)="clearInp()" class="crossIco"></div>
                    }
                </div>
            </div>
        </form>
    </div>
</section>

@if(reportDetails.length > 0){
<div class="card-details">
    @for(item of reportDetails; track item){
    <div class="dp-card">
        <div class="heading d-flex justify-content-between">
            <span class="card-title">Financial Year</span>
            <span class="card-text-right" style="color: var(--brand-primary); cursor: pointer;"
                (click)="getDateDetails(item.period)">{{item.period}}</span>
        </div>
        <div class="mob-details-div">
            <div class="d-flex justify-content-between">
                <span class="card-text-left">DP received deoghar</span>
                <span class="card-text-right">{{ item.dpTotal}}</span>
            </div>
            <div class="d-flex justify-content-between">
                <span class="card-text-left">SP received deoghar</span>
                <span class="card-text-right">{{ item.spTotal}}</span>
            </div>
            <div class="d-flex justify-content-between">
                <span class="card-text-left">Online mode submitted</span>
                <span class="card-text-right">{{ item.onlineTotal}}</span>
            </div>

            <div class="d-flex justify-content-between">
                <span class="card-text-left">Offline mode submitted</span>
                <span class="card-text-right">{{ item.offlineTotal}}</span>
            </div>
        </div>
    </div>
    }
</div>
}@else {
<div class="dp-card align-items-center">
    <div class="heading d-flex justify-content-between ">
        <span class="card-title">No records found</span>
    </div>
</div>
}
}@else{
<!-- @if(isFY){ -->
<div class="d-flex inpSec align-items-center justify-content-between">
    <div class="d-flex">
        <input type="text" class="dp-input-control searchInput" [formControl]="searchReq"
            placeholder="Search by anything" />
    </div>

    <div class="d-flex terms">
        <div class="each-term" [class.active-term]="terms === '1st'" (click)="getTerms('1st')">
            <!-- <span class="common-txt">1st Term</span> -->
            1st Term
        </div>
        <div class="each-term" [class.active-term]="terms === '2nd'" (click)="getTerms('2nd')">
            2nd Term
        </div>
        <div class="each-term" [class.active-term]="terms == '3rd'" (click)="getTerms('3rd')">
            3rd Term
        </div>
        <div class="each-term" [class.active-term]="terms == '4th'" (click)="getTerms('4th')">
            4th Term
        </div>
        <div class="each-term" [class.active-term]="terms == 'custom'" (click)="getTerms('custom')">
            Customize
        </div>
    </div>

</div>
<!-- } -->
@if(!isActive){
@if(dateDetails.length > 0){
<div class="card-details">
    @for(item of dateDetails; track item){
    <div class="dp-card">
        <div class="heading d-flex justify-content-between">
            <span class="card-title">Submitted Date</span>
            <span class="card-text-right">{{item.submitDate}}</span>
        </div>
        <div class="mob-details-div">
            <div class="d-flex justify-content-between">
                <span class="card-text-left">DP received deoghar</span>
                <span class="card-text-right">{{ item.dpTotal}}</span>
            </div>
            <div class="d-flex justify-content-between">
                <span class="card-text-left">SP received deoghar</span>
                <span class="card-text-right">{{ item.spTotal}}</span>
            </div>
            <div class="d-flex justify-content-between">
                <span class="card-text-left">Online mode submitted</span>
                <span class="card-text-right">{{ item.onlineTotal}}</span>
            </div>

            <div class="d-flex justify-content-between">
                <span class="card-text-left">Offline mode submitted</span>
                <span class="card-text-right">{{ item.offlineTotal}}</span>
            </div>
        </div>
    </div>
    }
</div>
}@else {
<div class="dp-card">
    <div class="heading d-flex justify-content-between align-items-center">
        <span class="card-title">No records found</span>
        <!-- <span class="card-text-right">{{item.submitDate}}</span> -->
    </div>
</div>
}
}@else{
@if(filterData.length > 0){
<div class="card-details">
    @for(item of filterData; track item){
    <div class="dp-card">
        <div class="heading d-flex justify-content-between">
            <span class="card-title">Submitted Date</span>
            <span class="card-text-right">{{item.submitDate}}</span>
        </div>
        <div class="mob-details-div">
            <div class="d-flex justify-content-between">
                <span class="card-text-left">DP received deoghar</span>
                <span class="card-text-right">{{ item.dpTotal}}</span>
            </div>
            <div class="d-flex justify-content-between">
                <span class="card-text-left">SP received deoghar</span>
                <span class="card-text-right">{{ item.spTotal}}</span>
            </div>
            <div class="d-flex justify-content-between">
                <span class="card-text-left">Online mode submitted</span>
                <span class="card-text-right">{{ item.onlineTotal}}</span>
            </div>

            <div class="d-flex justify-content-between">
                <span class="card-text-left">Offline mode submitted</span>
                <span class="card-text-right">{{ item.offlineTotal}}</span>
            </div>
        </div>
    </div>
    }
</div>
}@else{
<div class="dp-card">
    <div class="heading d-flex justify-content-between align-items-center">
        <span class="card-title">No records found</span>

    </div>
</div>
}
}

}
}
